/* Posternia Pro — scenes.js
   Sceny strony głównej sterowane przewijaniem (GSAP + ScrollTrigger). Ładowane przez każdą sekcję-scenę,
   więc chronione przed podwójnym uruchomieniem. Bez GSAP albo przy ograniczonym ruchu: widok statyczny (.is-static). */
(function () {
  'use strict';
  if (window.__pstrnScenes) return;
  window.__pstrnScenes = true;

  var theme = window.theme || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = !!(window.gsap && window.ScrollTrigger);
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function smooth(t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }
  var animated = hasGsap && !reduce;

  function scrollToProgress(section, p) {
    var top = section.getBoundingClientRect().top + window.scrollY;
    var y = top + p * (section.offsetHeight - window.innerHeight);
    if (theme.lenis) theme.lenis.scrollTo(y, { duration: 1.1 });
    else window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- Hero: wachlarz plakatów ---------- */
  function hero(section) {
    var fan = $('.hstudio__fan', section);
    if (!animated || !fan) return;
    var html = document.documentElement;
    var delay = html.classList.contains('intro-play') && !html.classList.contains('intro-done') ? 1200 : 60;
    // Po wejściu plakatów (animacja w CSS) przewijanie rozkłada wachlarz i przybliża środkowy plakat
    setTimeout(function () {
      gsap.set(fan, { '--spread': 0 });
      gsap.to(fan, {
        '--spread': 1, yPercent: -6, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top top', end: 'bottom top', scrub: .6 }
      });
      gsap.to($('.hstudio__copy', section), {
        yPercent: -30, opacity: .2, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top top', end: '60% top', scrub: .6 }
      });
    }, delay + 2200);
  }

  /* ---------- Rama 3D: obrót, rozłożenie na warstwy, złożenie, tył ---------- */
  function frame(section) {
    var obj = $('[data-frame-obj]', section);
    var steps = $$('[data-step]', section);
    var bar = $('[data-frame-progress]', section);
    if (!obj) return;
    if (!animated) { section.classList.add('is-static'); return; }
    var L = {
      frame: $('[data-layer="frame"]', obj), glass: $('[data-layer="glass"]', obj),
      print: $('[data-layer="print"]', obj), back: $('[data-layer="back"]', obj)
    };
    var callouts = $$('.sf-callout', obj);
    // Na stronie produktu rama w scenie ma kolor wybranego wykończenia
    document.addEventListener('variant:change', function (e) {
      if (e.target.closest && e.target.closest('[data-quick]')) return;
      if (e.detail && e.detail.frameColor) obj.style.setProperty('--frame', e.detail.frameColor);
    });
    var depth = function () { return obj.offsetWidth * .07; };
    gsap.set(obj, { rotationY: -58, rotationX: 18, scale: .82 });
    gsap.set(L.frame, { z: 0 });
    gsap.set(L.glass, { z: -2 });
    gsap.set(L.print, { z: -4 });
    gsap.set(L.back, { z: function () { return -(depth() - 2); } });
    gsap.set(callouts, { opacity: 0 });

    var tl = gsap.timeline({
      defaults: { ease: 'power2.inOut' },
      scrollTrigger: {
        trigger: section, start: 'top top', end: 'bottom bottom', scrub: .7, invalidateOnRefresh: true,
        onUpdate: function (self) {
          if (bar) bar.style.setProperty('--p', self.progress.toFixed(3));
          if (!steps.length) return;
          // Kroki: profil, plexi, wydruk, HDF (rozkładanie), gotowe (tył i przód)
          var marks = [0, .2, .3, .4, .62];
          var idx = 0;
          marks.forEach(function (m, i) { if (self.progress >= m && i < steps.length) idx = i; });
          steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        }
      }
    });
    tl.to(obj, { rotationY: -30, rotationX: 9, scale: 1, duration: 1.2 })
      .addLabel('explode')
      .to(L.frame, { z: function () { return depth() * 2.6; }, x: -36, y: -18, duration: 1 }, 'explode')
      .to(L.glass, { z: function () { return depth() * 1.3; }, x: -16, y: -8, '--shine': '10%', duration: 1 }, 'explode+=.2')
      .to(L.print, { z: 0, duration: 1 }, 'explode+=.35')
      .to(L.back, { z: function () { return -depth() * 2.4; }, x: 30, y: 14, duration: 1 }, 'explode+=.5')
      .to(callouts, { opacity: 1, duration: .35, stagger: .18, ease: 'power1.out' }, 'explode+=.5')
      .to(obj, { rotationY: -18, rotationX: 6, duration: 1.2, ease: 'none' })
      .to(callouts, { opacity: 0, duration: .3 })
      .to(L.frame, { z: 0, x: 0, y: 0, duration: 1 }, '<')
      .to(L.glass, { z: -2, x: 0, y: 0, '--shine': '80%', duration: 1 }, '<')
      .to(L.print, { z: -4, duration: 1 }, '<')
      .to(L.back, { z: function () { return -(depth() - 2); }, x: 0, y: 0, duration: 1 }, '<')
      .to(obj, { rotationY: 180, rotationX: 4, duration: 1.4 })
      .to(obj, { rotationY: 345, rotationX: 6, duration: 1.4 });
  }

  /* ---------- Formaty: plakat rośnie A4 → A1 ---------- */
  function format(section) {
    var poster = $('[data-format-poster]', section);
    var buttons = $$('[data-format-size]', section);
    if (!poster || !buttons.length) return;
    var heights = buttons.map(function (b) {
      var cm = (b.getAttribute('data-cm') || '').split(',');
      return cm.length === 2 ? Math.max(parseFloat(cm[0]), parseFloat(cm[1])) : 84;
    });
    var base = 84; // szerokość elementu w CSS odpowiada formatowi A1
    var scales = heights.map(function (h) { return h / base; });
    var current = -1;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      buttons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    };
    var setScale = function (s) { poster.style.setProperty('--sc', s.toFixed(4)); };
    setScale(scales[0]); setActive(0);

    if (!animated) {
      section.classList.add('is-static');
      buttons.forEach(function (b, i) { b.addEventListener('click', function () { setScale(scales[i]); setActive(i); }); });
      return;
    }
    section.classList.add('is-scrubbing');
    var n = scales.length;
    ScrollTrigger.create({
      trigger: section, start: 'top top', end: 'bottom bottom', scrub: true,
      onUpdate: function (self) {
        var s = self.progress * (n - 1);
        var i = Math.min(n - 2, Math.floor(s));
        if (n === 1) { setScale(scales[0]); return; }
        var f = smooth((s - i - .25) / .5);
        setScale(scales[i] + (scales[i + 1] - scales[i]) * f);
        setActive(f > .5 ? i + 1 : i);
      }
    });
    buttons.forEach(function (b, i) { b.addEventListener('click', function () { scrollToProgress(section, n > 1 ? i / (n - 1) : 0); }); });
  }

  /* ---------- Karuzela 3D: przewijanie obraca pierścień plakatów ---------- */
  function ring(section) {
    var ringEl = $('[data-ring]', section);
    var stage = $('[data-ring-stage]', section);
    var items = $$('[data-ring-item]', section);
    var n = items.length;
    if (!ringEl || n < 2) return;
    var step = 360 / n;
    var cap = $('[data-ring-caption]', section);
    var capE = $('[data-ring-eyebrow]', section), capT = $('[data-ring-title]', section), capP = $('[data-ring-price]', section);
    var prev = $('[data-ring-prev]', section), next = $('[data-ring-next]', section);
    var bar = $('[data-ring-progress]', section);
    var active = -1, cur = 0, dragged = false;

    function setActive(i) {
      if (i === active) return;
      active = i;
      var it = items[i];
      items.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      if (!cap) return;
      capE.textContent = it.dataset.eyebrow || '';
      capT.textContent = it.dataset.title || '';
      if (it.dataset.url) capT.setAttribute('href', it.dataset.url);
      capP.textContent = it.dataset.price || '';
      cap.classList.remove('is-swap'); void cap.offsetWidth; cap.classList.add('is-swap');
    }
    // pos: indeks plakatu z przodu (ułamkowy w trakcie obrotu)
    function render(pos) {
      cur = pos;
      var rot = -pos * step;
      ringEl.style.setProperty('--rot', rot.toFixed(2) + 'deg');
      items.forEach(function (el, j) {
        var a = ((j * step + rot) % 360 + 540) % 360 - 180;
        el.style.setProperty('--d', (Math.abs(a) / 180).toFixed(3));
      });
      setActive(clamp(Math.round(pos), 0, n - 1));
    }
    render(0);
    if (!animated) { section.classList.add('is-static'); return; }

    // Przy każdym plakacie krótki przystanek, między nimi płynny obrót
    var dwell = function (p) {
      var s = p * (n - 1), i = Math.floor(s);
      if (i >= n - 1) return n - 1;
      return i + smooth((s - i - .16) / .68);
    };
    var proxy = { pos: 0 };
    ScrollTrigger.create({
      trigger: section, start: 'top top', end: 'bottom bottom',
      onUpdate: function (self) {
        if (bar) bar.style.setProperty('--p', self.progress.toFixed(3));
        gsap.to(proxy, { pos: dwell(self.progress), duration: .55, ease: 'power3.out', overwrite: true, onUpdate: function () { render(proxy.pos); } });
      }
    });
    var go = function (i) { scrollToProgress(section, clamp(i, 0, n - 1) / (n - 1)); };
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });

    // Plakat z przodu otwiera produkt, kliknięcie innego obraca do niego
    items.forEach(function (el, j) {
      var link = $('[data-ring-link]', el);
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (dragged || j !== active) { e.preventDefault(); if (!dragged) go(j); }
      });
      link.addEventListener('focus', function () { if (j !== active && link.matches(':focus-visible')) go(j); });
    });

    // Przeciąganie w poziomie obraca pierścień (przez przewinięcie strony, więc wszystko zostaje zsynchronizowane)
    if (!stage) return;
    var down = false, sx = 0, lastX = 0;
    var perItem = function () { return (section.offsetHeight - window.innerHeight) / (n - 1); };
    var moveBy = function (items_) {
      var y = window.scrollY + items_ * perItem();
      if (theme.lenis) theme.lenis.scrollTo(y, { immediate: true });
      else window.scrollTo(0, y);
    };
    var end = function () {
      if (!down) return;
      down = false;
      stage.classList.remove('is-dragging');
      if (dragged) { go(Math.round(cur)); setTimeout(function () { dragged = false; }, 60); }
    };
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true; dragged = false; sx = lastX = e.clientX;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (!dragged && Math.abs(e.clientX - sx) > 6) { dragged = true; stage.classList.add('is-dragging'); }
      if (!dragged) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      var unit = Math.max(120, ringEl.offsetWidth * 1.15);
      moveBy(-dx / unit);
    });
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  }

  /* ---------- Plakat na ścianie: format rośnie A4 → A1, kamera odjeżdża, zapada wieczór ---------- */
  function roomScene(section) {
    var view = $('[data-room-view]', section), cam = $('[data-room-camera]', section);
    var wrap = $('[data-room-poster]', section), hang = $('[data-room-hang]', section);
    var sizeBtns = $$('[data-room-size]', section), picks = $$('[data-room-pick-poster]', section);
    var roomBtns = $$('[data-room-pick-room]', section), scenes = $$('[data-sroom-scene]', section);
    var link = $('[data-room-link]', section), lightBtn = $('[data-room-light]', section), live = $('[data-room-live]', section);
    var dimW = $('[data-dim="w"]', section), dimH = $('[data-dim="h"]', section);
    if (!view || !cam || !wrap || !sizeBtns.length) return;
    // Miejsce plakatu w każdym wnętrzu: środek (cm od lewej) i dolna krawędź (cm od sufitu). Tam, gdzie nad meblem
    // nie zmieściłby się A1 (wezgłowie, monitor), plakat wisi obok: nad szafką nocną albo przy biurku.
    var SPOTS = { salon: [210, 116], sypialnia: [329, 150], biuro: [330, 124], przedpokoj: [196, 128] };
    var LAMPS = { salon: [354, 146], sypialnia: [91, 146], biuro: [163, 121], przedpokoj: [40, 30] };
    var ZMAX = window.matchMedia('(max-width: 749px)').matches ? 2.3 : 2;
    var cms = sizeBtns.map(function (b) {
      var c = (b.getAttribute('data-cm') || '').split(',');
      return c.length === 2 ? [parseFloat(c[0]), parseFloat(c[1])] : [42, 59.4];
    });
    var n = cms.length, last = Math.max(1, n - 1);
    var st = { pos: 0, night: 0, room: scenes[0] ? scenes[0].getAttribute('data-sroom-scene') : 'salon', manual: null, active: -1 };
    var poster = function () { return $('[data-poster]', wrap); };
    var num = function (name) { var p = poster(); return parseFloat(p ? p.style.getPropertyValue(name) : '') || 0; };
    var fmt = function (v) { return String(Math.round(v * 10) / 10).replace('.', ','); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var sizeAt = function (pos) {
      if (n === 1) return cms[0];
      var i = Math.min(n - 2, Math.floor(pos)), f = pos - i;
      return [lerp(cms[i][0], cms[i + 1][0], f), lerp(cms[i][1], cms[i + 1][1], f)];
    };

    function render() {
      var W = view.clientWidth, H = view.clientHeight;
      if (!W || !H) return;
      var s = Math.max(W / 420, H / 270), oy = H - 270 * s;
      // Wąski kadr (telefon) przycina boki wnętrza, więc każde wnętrze przesuwa się tak, żeby jego plakat był w kadrze
      var panFor = function (name) { return clamp(W / 2 - (SPOTS[name] || SPOTS.salon)[0] * s, W - 420 * s, 0); };
      var ox = panFor(st.room);
      if (W !== st.w || H !== st.h) {
        st.w = W; st.h = H;
        scenes.forEach(function (el) {
          el.style.width = (420 * s).toFixed(1) + 'px';
          el.style.height = (270 * s).toFixed(1) + 'px';
          el.style.transform = 'translate(' + panFor(el.getAttribute('data-sroom-scene')).toFixed(1) + 'px,' + oy.toFixed(1) + 'px)';
        });
      }
      var c = sizeAt(st.pos), pw = Math.min(c[0], c[1]), ph = Math.max(c[0], c[1]);
      var fx = num('--fx') / 100, fy = num('--fy') / 100;
      var w = pw / (1 - 2 * fx) * s, h = ph / (1 - 2 * fy) * s;
      var spot = SPOTS[st.room] || SPOTS.salon;
      var x = ox + spot[0] * s - w / 2, y = oy + spot[1] * s - h;
      wrap.style.width = w.toFixed(1) + 'px';
      wrap.style.height = h.toFixed(1) + 'px';
      wrap.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      // Kamera: przy A4 blisko plakatu, przy A1 widać całe wnętrze
      var z = 1 + (ZMAX - 1) * (1 - st.pos / last), cx = x + w / 2, cy = y + h * .6;
      cam.style.setProperty('--ox', cx.toFixed(1) + 'px');
      cam.style.setProperty('--oy', cy.toFixed(1) + 'px');
      cam.style.setProperty('--z', z.toFixed(4));
      var L = LAMPS[st.room] || [380, 140];
      cam.style.setProperty('--lx', (ox + L[0] * s).toFixed(1) + 'px');
      cam.style.setProperty('--ly', (oy + L[1] * s).toFixed(1) + 'px');
      section.style.setProperty('--night', st.night.toFixed(3));
      section.classList.toggle('is-night', st.night > .5);
      wrap.style.setProperty('--sx', lerp(7, L[0] > spot[0] ? -9 : 9, st.night).toFixed(1) + 'px');
      if (hang) hang.style.setProperty('--glare', (92 - st.pos / last * 74).toFixed(1) + '%');
      // Miarka wokół samego wydruku (bez ramy), przeliczona na ekran po przybliżeniu kamery
      var tx = function (v) { return cx + (v - cx) * z; }, ty = function (v) { return cy + (v - cy) * z; };
      var l = tx(x + w * fx), r = tx(x + w * (1 - fx)), t = ty(y + h * fy), b = ty(y + h * (1 - fy));
      if (dimW) { dimW.style.transform = 'translate(' + l.toFixed(1) + 'px,' + (t - 14).toFixed(1) + 'px)'; dimW.style.width = (r - l).toFixed(1) + 'px'; $('b', dimW).textContent = fmt(pw) + ' cm'; }
      if (dimH) { dimH.style.transform = 'translate(' + (r + 14).toFixed(1) + 'px,' + t.toFixed(1) + 'px)'; dimH.style.height = (b - t).toFixed(1) + 'px'; $('b', dimH).textContent = fmt(ph) + ' cm'; }
      var a = clamp(Math.round(st.pos), 0, n - 1);
      if (a !== st.active) {
        st.active = a;
        sizeBtns.forEach(function (btn, j) { btn.classList.toggle('is-active', j === a); btn.setAttribute('aria-pressed', j === a ? 'true' : 'false'); });
        if (live) live.textContent = sizeBtns[a].getAttribute('data-room-size') + ', ' + fmt(Math.min(cms[a][0], cms[a][1])) + ' × ' + fmt(Math.max(cms[a][0], cms[a][1])) + ' cm';
      }
    }

    // Ceny formatów (w ramie) dla wybranego plakatu
    var setPrices = function (btn) {
      var prices = {};
      try { prices = JSON.parse(btn.getAttribute('data-prices') || '{}'); } catch (e) {}
      sizeBtns.forEach(function (b) {
        var p = prices[b.getAttribute('data-room-size')], el = $('[data-room-size-price]', b);
        if (el) el.textContent = p != null && theme.formatMoney ? theme.formatMoney(p) : '';
      });
    };
    var pickPoster = function (btn) {
      picks.forEach(function (p) { p.setAttribute('aria-pressed', p === btn ? 'true' : 'false'); });
      setPrices(btn);
      if (link) link.href = btn.getAttribute('data-url');
      var src = btn.getAttribute('data-src'), p = poster(), img = p && $('img', p);
      if (!src || !img) return;
      var swap = function () {
        img.srcset = btn.getAttribute('data-srcset') || '';
        img.src = src;
        if (theme.posterVars) theme.posterVars(p, parseFloat(btn.getAttribute('data-ratio')));
        render();
      };
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        if (reduce || !hang.animate) return swap();
        // Plakat obraca się na zawieszce i wraca z nowym wzorem
        hang.animate([{ transform: 'none' }, { transform: 'perspective(900px) rotateY(88deg)' }], { duration: 220, easing: 'cubic-bezier(.55,0,.75,.2)' }).onfinish = function () {
          swap();
          hang.animate([{ transform: 'perspective(900px) rotateY(-88deg)' }, { transform: 'none' }], { duration: 520, easing: 'cubic-bezier(.34,1.56,.64,1)' });
        };
      };
      pre.src = src;
    };
    var pickRoom = function (name) {
      st.room = name;
      roomBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-room-pick-room') === name ? 'true' : 'false'); });
      scenes.forEach(function (s) { s.classList.toggle('is-current', s.getAttribute('data-sroom-scene') === name); });
      wrap.classList.add('is-moving');
      render();
      setTimeout(function () { wrap.classList.remove('is-moving'); }, 820);
    };
    picks.forEach(function (b) { b.addEventListener('click', function () { pickPoster(b); }); });
    roomBtns.forEach(function (b) { b.addEventListener('click', function () { pickRoom(b.getAttribute('data-room-pick-room')); }); });
    if (picks[0]) setPrices(picks[0]);
    window.addEventListener('resize', function () { render(); });
    var setNight = function (target) {
      if (!animated) { st.night = target; render(); return; }
      gsap.to(st, { night: target, duration: 1.1, ease: 'power2.inOut', overwrite: 'auto', onUpdate: render });
    };
    if (lightBtn) lightBtn.addEventListener('click', function () {
      st.manual = st.night > .5 ? 0 : 1;
      lightBtn.setAttribute('aria-pressed', st.manual ? 'true' : 'false');
      setNight(st.manual);
    });
    render();

    // Plakat „zawisa” na ścianie przy pierwszym pojawieniu się sceny
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { section.classList.add('is-hung'); io.disconnect(); } }, { threshold: .35 });
      io.observe(view);
    }

    if (!animated) {
      section.classList.add('is-static');
      sizeBtns.forEach(function (b, i) { b.addEventListener('click', function () { st.pos = i; render(); }); });
      return;
    }
    var dwell = function (p) {
      var sp = p * last, i = Math.floor(sp);
      if (i >= last) return last;
      return i + smooth((sp - i - .15) / .7);
    };
    var proxy = { pos: 0, night: 0 };
    ScrollTrigger.create({
      trigger: section, start: 'top top', end: 'bottom bottom',
      onUpdate: function (self) {
        var target = { pos: dwell(self.progress), duration: .6, ease: 'power3.out', overwrite: true, onUpdate: function () { st.pos = proxy.pos; if (st.manual == null) st.night = proxy.night; render(); } };
        target.night = smooth((self.progress - .55) / .4);
        gsap.to(proxy, target);
      }
    });
    sizeBtns.forEach(function (b, i) { b.addEventListener('click', function () { scrollToProgress(section, i / last); }); });
  }

  var registry = { hero: hero, frame: frame, format: format, ring: ring, room: roomScene };
  function init(root) {
    $$('[data-scene]', root).forEach(function (section) {
      if (section.dataset.sceneReady) return;
      section.dataset.sceneReady = '1';
      var fn = registry[section.getAttribute('data-scene')];
      if (fn) fn(section);
    });
    if (hasGsap) requestAnimationFrame(function () { ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('load', function () { if (hasGsap) ScrollTrigger.refresh(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
